export default "<p>salesofstock-redirect works!</p>\n";